module.exports = __webpack_public_path__ + "static/arnaud-5a1d94c7f4f37226d6efaea7b2abe3e5.png";